
import type { Metadata } from "next";
import { Header } from "@/components/header/Header";
import  InnerHero  from "@/components/InnerHero/InnerHero";
import ProductStack from "@/components/ProductsPage/ProductStack";
import CTA from "@/components/ProductsPage/CTA/CTA";
import { Footer } from "@/components/Footer/Footer";

export const metadata: Metadata = {
  title: "Contact — Queenscraft",
  description:
    "Get in touch with Queenscraft for general enquiries, trade and wholesale, or press and partnerships.",
};

export default function ContactPage() {
  return (
    <>
      <Header />
      <main>
        <InnerHero pageKey="products" />
        <ProductStack />
        <CTA />
      </main>
      <Footer />
    </>
  );
}

